import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import Logo from "../components/Logo";
import { useAuth } from "../lib/auth";
import { formatApiError } from "../lib/api";
import { toast, Toaster } from "sonner";

export default function AdminLoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      const msg = formatApiError(err.response?.data?.detail) || err.message;
      setError(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-secondary/50 p-6">
      <Toaster position="top-right" richColors />
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-block"><Logo size="lg" /></div>
          <p className="text-muted-foreground text-sm mt-3">Espace administrateur</p>
        </div>
        <form onSubmit={submit} className="surface-card p-8 space-y-5 bg-white" data-testid="admin-login-form">
          <label className="block">
            <span className="text-sm font-semibold">Email</span>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="admin-email"
              className="mt-2 w-full px-5 py-3.5 border border-input rounded-full bg-background focus:outline-none focus:ring-2 focus:ring-accent/30 focus:border-accent"
            />
          </label>
          <label className="block">
            <span className="text-sm font-semibold">Mot de passe</span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="admin-password"
              className="mt-2 w-full px-5 py-3.5 border border-input rounded-full bg-background focus:outline-none focus:ring-2 focus:ring-accent/30 focus:border-accent"
            />
          </label>
          {error && <div className="text-destructive text-sm bg-destructive/10 px-4 py-2.5 rounded-xl" data-testid="admin-error">{error}</div>}
          <button type="submit" disabled={loading} className="btn-accent w-full disabled:opacity-50" data-testid="admin-submit">
            <Lock size={14} /> {loading ? "Connexion…" : "Se connecter"}
          </button>
        </form>
      </div>
    </div>
  );
}
